import React, { Component } from 'react'
import Header from '../common/Header'
import Footer from '../common/Footer'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import { DatePicker, Upload, message, Modal, Input, Select } from 'antd';
import ajax from '../utils/ajax'
import functions from '../utils/functions'
import Notification from '../common/Notification'


const { RangePicker } = DatePicker;
const { TextArea } = Input;
const { Option } = Select;

class Services extends Component {

  state = {
    username: '',
    password: '',
    type: '',
    info: '',
    load: false,
    showMsg: false,

    phone: '',
    email: '',
    date: '',
    fullname: '',
    service: '',
    doctor: '',
    message: ''
  }

  onChangeFullname = (event) => {
    //console.log("tadaa ", event.target.value)
    this.setState({ fullname: event.target.value })
  }

  onChangePhone = (event) => {
    //console.log("tadaa ", event.target.value)
    this.setState({ phone: event.target.value })
  }

  onChangeEmail = (event) => {
    //console.log("tadaa ", event.target.value)
    this.setState({ email: event.target.value })
  }

  onChangeType = (value) => {

    console.log("tadaa ", value.target.value)

    this.setState({
      service: value.target.value
    })
  }

  onChangeDoctor = (events) => {
    console.log("tadaa ", events.target.value)
    this.setState({ doctor: events.target.value })
  }

  onChangeDate = (event) => {
    //console.log("tadaa ", event.target.value)
    this.setState({ date: event.target.value })
  }

  onChangeDesc = (event) => {
    //console.log("tadaa ", event.target.value)
    this.setState({ message: event.target.value })
  }




  onPressSchedule = async (event) => {

    event.preventDefault()
    const { phone, email, date, fullname, service, doctor, message } = this.state

    if (phone.length > 0 && email.length > 0 && date.length > 0 && fullname.length > 0 && service.length > 0 && doctor.length > 0 && message.length > 0) {

      this.setState({
        type: '',
        info: '',
        load: true,
        showMsg: false
      })
      //fetch login from the API
      const server_response = await ajax.sendMail(phone, email, date, fullname, service, doctor, message)


      if (server_response.status === "OK") {
        this.setState({
          type: 'alert alert-success',
          info: server_response.message,
          load: '',
        })
        window.location.reload()

      } else {

        this.setState({
          type: 'alert alert-danger',
          info: server_response.message,
          load: '',
        })

      }



    } else {

      this.setState({
        type: 'alert alert-danger',
        info: 'All Fields are required',
        load: false,
      })
    }


  }

  render() {
    return (
      <>
        <body>
          {<Header />}


          <div class="homepage4-body">
            <div class="vl-offcanvas">
              <div class="vl-offcanvas-wrapper">
                <div class="vl-offcanvas-header d-flex justify-content-between align-items-center mb-90">
                  <div class="vl-offcanvas-logo">
                    <a href="/"><img src="assets/img/logo/rehabLogo.png" alt="" /></a>
                  </div>
                  <div class="vl-offcanvas-close">
                    <button class="vl-offcanvas-close-toggle"><i class="fa-solid fa-xmark"></i></button>
                  </div>
                </div>

                <div class="vl-offcanvas-menu d-lg-none mb-40">
                  <nav></nav>
                </div>
                <div class="space20"></div>

                <div class="vl-offcanvas-info">

                  <div class="btn-area1">

                    <div class="btn-area1">
                      <a href="https://wa.me/256755260852" target='_blank' class="vl-btn7"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <g clip-path="url(#clip0_5832_90599)">
                          <path d="M4.32688 1.17695C4.79912 1.27456 5.1752 1.59185 5.40887 2.01104L6.15321 3.34641C6.42738 3.83825 6.65811 4.25215 6.80878 4.61195C6.96862 4.99364 7.06355 5.37002 7.02016 5.78615C6.97676 6.20229 6.80622 6.55099 6.57107 6.89148C6.3494 7.21245 6.03823 7.56985 5.66848 7.99454L4.57431 9.25135C4.37824 9.4766 4.2802 9.58919 4.27124 9.72994C4.26228 9.87069 4.34263 9.99094 4.50333 10.2314C5.87299 12.2806 7.71894 14.1272 9.76983 15.498C10.0103 15.6587 10.1305 15.739 10.2712 15.7301C10.412 15.7211 10.5247 15.6231 10.7498 15.427L12.0067 14.3328C12.4314 13.963 12.7888 13.6519 13.1098 13.4302C13.4502 13.195 13.799 13.0245 14.2151 12.9811C14.6312 12.9377 15.0077 13.0327 15.3893 13.1925C15.7491 13.3432 16.163 13.5739 16.6547 13.848L17.9902 14.5924C18.4094 14.8261 18.7267 15.2022 18.8243 15.6744C18.9229 16.1515 18.7775 16.6312 18.4562 17.0254C17.2904 18.4557 15.4227 19.3664 13.4633 18.9711C12.259 18.7282 11.0707 18.3234 9.63342 17.4992C6.74558 15.843 4.15636 13.2524 2.50212 10.3679C1.67786 8.9306 1.2731 7.74232 1.03015 6.53794C0.634898 4.57858 1.54559 2.71085 2.9759 1.5451C3.37009 1.22381 3.84971 1.07834 4.32688 1.17695Z" fill="white" />
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M11.3045 1.54C11.432 1.0978 11.894 0.842779 12.3362 0.970388C15.559 1.90041 18.0973 4.43862 19.0275 7.66132C19.155 8.1035 18.9 8.56545 18.4579 8.69304C18.0157 8.8207 17.5537 8.5657 17.4261 8.1235C16.6548 5.45101 14.5466 3.34295 11.874 2.57171C11.4319 2.4441 11.1769 1.98219 11.3045 1.54ZM10.793 5.47187C10.973 5.04825 11.4622 4.85066 11.8859 5.03055C13.2706 5.6186 14.3793 6.72725 14.9673 8.11199C15.1472 8.53562 14.9496 9.02487 14.526 9.20479C14.1024 9.38462 13.6131 9.18704 13.4332 8.76345C13.014 7.77614 12.2217 6.9839 11.2344 6.56463C10.8108 6.38474 10.6132 5.8955 10.793 5.47187Z" fill="white" />
                        </g>
                        <defs>
                          <clipPath id="clip0_5832_90599">
                            <rect width="20" height="20" fill="white" />
                          </clipPath>
                        </defs>
                      </svg> (0) 755 260852</a>
                    </div>

                    <br />

                    <a href="https://wa.me/256755260852" class="vl-btn4">WhatsApp<span><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M11 0.25C5.06294 0.25 0.25 5.06294 0.25 11C0.25 16.9371 5.06294 21.75 11 21.75C16.9371 21.75 21.75 16.9371 21.75 11C21.75 5.06294 16.9371 0.25 11 0.25ZM10 7C9.5955 7 9.2309 7.24364 9.0761 7.61732C8.92134 7.99099 9.0069 8.42111 9.2929 8.70711L10.5858 10L7.29289 13.2929C6.90237 13.6834 6.90237 14.3166 7.29289 14.7071C7.68342 15.0976 8.31658 15.0976 8.70711 14.7071L12 11.4142L13.2929 12.7071C13.5789 12.9931 14.009 13.0787 14.3827 12.9239C14.7564 12.7691 15 12.4045 15 12V8C15 7.44772 14.5523 7 14 7H10Z" fill="white" />
                    </svg></span></a>
                  </div>


                </div>

                <div class="space20"></div>
                <div class="vl-offcanvas-info">
                  <h3 class="vl-offcanvas-sm-title">Contact Us</h3>
                  <div class="space20"></div>
                  <span><a href="#"> <i class="fa-solid fa-phone"></i> +256755260852</a></span>
                  <span><a href="#"><i class="fa-regular fa-envelope"></i> info@ntindamedic.com</a></span>
                  <span><a href="#"><i class="fa-solid fa-location-dot"></i> Ntinda Stretcher Road</a></span>
                </div>
                <div class="space20"></div>
                <div class="vl-offcanvas-social">
                  <h3 class="vl-offcanvas-sm-title">Follow Us</h3>
                  <div class="space20"></div>
                  <a href="#"><i class="fab fa-facebook-f"></i></a>
                  <a href="#"><i class="fab fa-twitter"></i></a>
                  <a href="#"><i class="fab fa-linkedin-in"></i></a>
                  <a href="#"><i class="fab fa-instagram"></i></a>
                </div>

              </div>
            </div>
            <div class="vl-offcanvas-overlay"></div>
          </div>


          <div class="inner-header-section-area" style={{ backgroundImage: `url(assets/img/all-images/bg/bg9.png)`, backgroundPosition: 'center top', backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }}>
            <img src="assets/img/elements/elements28.png" alt="" class="elements28" />
            <div class="container">
              <div class="row align-items-center">
                <div class="col-lg-12">
                  <div class="hero-header">
                    <h1 class="text-anime-style-1">Our Services</h1>
                    <div class="space28"></div>
                    <a href="/" class="bradecrumb">Home <i class="fa-solid fa-angle-right"></i> Our Services</a>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div class="service-inner-area sp8">
            <div class="container">
              <div class="row">
                <div class="col-lg-3 col-md-6">
                  <div class="service4-boxarea">
                    <div class="content-area">
                      <a href="#" class="title">Physiotherapy services</a>
                      <div class="space16"></div>
                      <p>We provide client-centered care focused on helping you recover, eliminate pain, post-surgery rehabilitation and restoring normal movement of joints, nerves, and muscles.</p>
                      <div class="space24"></div>
                      <a href="https://wa.me/256755260852" target='_blank' class="readmore">
                        Learn More
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                          <g clip-path="url(#clip0_5927_10805)">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.99992 0.833008C4.04188 0.833008 0.833252 4.04163 0.833252 7.99967C0.833252 11.9577 4.04188 15.1663 7.99992 15.1663C11.958 15.1663 15.1666 11.9577 15.1666 7.99967C15.1666 4.04163 11.958 0.833008 7.99992 0.833008ZM7.33325 5.33301C7.06359 5.33301 6.82052 5.49543 6.71732 5.74455C6.61415 5.99367 6.67119 6.28042 6.86185 6.47108L7.72379 7.33301L5.52851 9.52827C5.26817 9.78861 5.26817 10.2107 5.52851 10.4711C5.78887 10.7314 6.21097 10.7314 6.47133 10.4711L8.66659 8.27581L9.52852 9.13774C9.71919 9.32841 10.0059 9.38547 10.2551 9.28227C10.5042 9.17907 10.6666 8.93601 10.6666 8.66634V5.99967C10.6666 5.63149 10.3681 5.33301 9.99992 5.33301H7.33325Z" fill="#4416FF" />
                          </g>
                          <defs>
                            <clipPath id="clip0_5927_10805">
                              <rect width="16" height="16" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </a>
                    </div>

                    <div class="img1 image-anime">
                      <img src="assets/img/all-images/service/service-img17.png" alt="" />
                    </div>
                  </div>
                </div>

                <div class="col-lg-3 col-md-6">
                  <div class="service4-boxarea">
                    <div class="content-area">
                      <a href="#" class="title">Orthopedic services</a>
                      <div class="space16"></div>
                      <p>Our orthopedic services includes, Treatment of Musculoskeletal disorders such as Rheumatoid Arthritis, Osteoarthritis and gout, Fixation of open fractures and injuries, metabolic and Musculoskeletal disorders.</p>
                      <div class="space24"></div>
                      <a href="https://wa.me/256755260852" target='_blank' class="readmore">
                        Learn More
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                          <g clip-path="url(#clip0_5927_10805)">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.99992 0.833008C4.04188 0.833008 0.833252 4.04163 0.833252 7.99967C0.833252 11.9577 4.04188 15.1663 7.99992 15.1663C11.958 15.1663 15.1666 11.9577 15.1666 7.99967C15.1666 4.04163 11.958 0.833008 7.99992 0.833008ZM7.33325 5.33301C7.06359 5.33301 6.82052 5.49543 6.71732 5.74455C6.61415 5.99367 6.67119 6.28042 6.86185 6.47108L7.72379 7.33301L5.52851 9.52827C5.26817 9.78861 5.26817 10.2107 5.52851 10.4711C5.78887 10.7314 6.21097 10.7314 6.47133 10.4711L8.66659 8.27581L9.52852 9.13774C9.71919 9.32841 10.0059 9.38547 10.2551 9.28227C10.5042 9.17907 10.6666 8.93601 10.6666 8.66634V5.99967C10.6666 5.63149 10.3681 5.33301 9.99992 5.33301H7.33325Z" fill="#4416FF" />
                          </g>
                          <defs>
                            <clipPath id="clip0_5927_108055">
                              <rect width="16" height="16" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </a>
                    </div>

                    <div class="img1 image-anime">
                      <img src="assets/img/all-images/service/service-img17.jpg" alt="" />
                    </div>
                  </div>
                </div>

                <div class="col-lg-3 col-md-6">
                  <div class="service4-boxarea">
                    <div class="content-area">
                      <a href="#" class="title">Stroke & Neurological</a>
                      <div class="space16"></div>
                      <p>We Specialize in the diagnosis, treatment and monitoring of Early neurological rehabilitation to help optimize individual physical and cognitive recovery and enhance quality of life.</p>
                      <div class="space24"></div>
                      <a href="https://wa.me/256755260852" target='_blank' class="readmore">
                        Learn More
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                          <g clip-path="url(#clip0_5927_10805)">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.99992 0.833008C4.04188 0.833008 0.833252 4.04163 0.833252 7.99967C0.833252 11.9577 4.04188 15.1663 7.99992 15.1663C11.958 15.1663 15.1666 11.9577 15.1666 7.99967C15.1666 4.04163 11.958 0.833008 7.99992 0.833008ZM7.33325 5.33301C7.06359 5.33301 6.82052 5.49543 6.71732 5.74455C6.61415 5.99367 6.67119 6.28042 6.86185 6.47108L7.72379 7.33301L5.52851 9.52827C5.26817 9.78861 5.26817 10.2107 5.52851 10.4711C5.78887 10.7314 6.21097 10.7314 6.47133 10.4711L8.66659 8.27581L9.52852 9.13774C9.71919 9.32841 10.0059 9.38547 10.2551 9.28227C10.5042 9.17907 10.6666 8.93601 10.6666 8.66634V5.99967C10.6666 5.63149 10.3681 5.33301 9.99992 5.33301H7.33325Z" fill="#4416FF" />
                          </g>
                          <defs>
                            <clipPath id="clip0_5927_108057">
                              <rect width="16" height="16" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </a>
                    </div>

                    <div class="img1 image-anime">
                      <img src="assets/img/all-images/service/service-img202.png" alt="" />
                    </div>
                  </div>
                </div>

                <div class="col-lg-3 col-md-6">
                  <div class="service4-boxarea">
                    <div class="content-area">
                      <a href="#" class="title">Pediatric Rehabilitation</a>
                      <div class="space16"></div>
                      <p>Our team works closely with your pediatrician to provide customized rehabilitation plans to address a wide range of symptoms and diagnoses with the goal of maximizing active participation of children</p>
                      <div class="space24"></div>
                      <a href="https://wa.me/256755260852" target='_blank' class="readmore">
                        Learn More
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                          <g clip-path="url(#clip0_5927_10805)">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.99992 0.833008C4.04188 0.833008 0.833252 4.04163 0.833252 7.99967C0.833252 11.9577 4.04188 15.1663 7.99992 15.1663C11.958 15.1663 15.1666 11.9577 15.1666 7.99967C15.1666 4.04163 11.958 0.833008 7.99992 0.833008ZM7.33325 5.33301C7.06359 5.33301 6.82052 5.49543 6.71732 5.74455C6.61415 5.99367 6.67119 6.28042 6.86185 6.47108L7.72379 7.33301L5.52851 9.52827C5.26817 9.78861 5.26817 10.2107 5.52851 10.4711C5.78887 10.7314 6.21097 10.7314 6.47133 10.4711L8.66659 8.27581L9.52852 9.13774C9.71919 9.32841 10.0059 9.38547 10.2551 9.28227C10.5042 9.17907 10.6666 8.93601 10.6666 8.66634V5.99967C10.6666 5.63149 10.3681 5.33301 9.99992 5.33301H7.33325Z" fill="#4416FF" />
                          </g>
                          <defs>
                            <clipPath id="clip0_5927_108051">
                              <rect width="16" height="16" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </a>
                    </div>

                    <div class="img1 image-anime">
                      <img src="assets/img/all-images/service/service-img18.jpg" alt="" />
                    </div>
                  </div>
                </div>

                <div class="col-lg-3 col-md-6">
                  <div class="service4-boxarea">
                    <div class="content-area">
                      <a href="#" class="title">Sports Injury {/*<!--Rehabilitation--> */}</a>
                      <div class="space16"></div>
                      <p>We treat a wide range of conditions including skeleton injuries, acute Sprains and strains, shoulder and joint dislocations, Foot and ankle disfunctions,tendonitis, Hand Injuries and also Tendon and ligament repairs.</p>
                      <div class="space24"></div>
                      <a href="https://wa.me/256755260852" target='_blank' class="readmore">
                        Learn More
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                          <g clip-path="url(#clip0_5927_10805)">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.99992 0.833008C4.04188 0.833008 0.833252 4.04163 0.833252 7.99967C0.833252 11.9577 4.04188 15.1663 7.99992 15.1663C11.958 15.1663 15.1666 11.9577 15.1666 7.99967C15.1666 4.04163 11.958 0.833008 7.99992 0.833008ZM7.33325 5.33301C7.06359 5.33301 6.82052 5.49543 6.71732 5.74455C6.61415 5.99367 6.67119 6.28042 6.86185 6.47108L7.72379 7.33301L5.52851 9.52827C5.26817 9.78861 5.26817 10.2107 5.52851 10.4711C5.78887 10.7314 6.21097 10.7314 6.47133 10.4711L8.66659 8.27581L9.52852 9.13774C9.71919 9.32841 10.0059 9.38547 10.2551 9.28227C10.5042 9.17907 10.6666 8.93601 10.6666 8.66634V5.99967C10.6666 5.63149 10.3681 5.33301 9.99992 5.33301H7.33325Z" fill="#4416FF" />
                          </g>
                          <defs>
                            <clipPath id="clip0_5927_108052">
                              <rect width="16" height="16" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </a>
                    </div>

                    <div class="img1 image-anime">
                      <img src="assets/img/all-images/service/service-img19.png" alt="" />
                    </div>
                  </div>
                </div>

                <div class="col-lg-3 col-md-6">
                  <div class="service4-boxarea">
                    <div class="content-area">
                      <a href="#" class="title">Pain Management</a>
                      <div class="space16"></div>
                      <p>Specializing in the diagnosis and treatment of pain-related conditions. We aim at eliminating pain such as back, neck, shoulder, elbow and knee pains which result from all sorts of activity or illnesses.</p>
                      <div class="space24"></div>
                      <a href="https://wa.me/256755260852" target='_blank' class="readmore">
                        Learn More
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                          <g clip-path="url(#clip0_5927_10805)">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.99992 0.833008C4.04188 0.833008 0.833252 4.04163 0.833252 7.99967C0.833252 11.9577 4.04188 15.1663 7.99992 15.1663C11.958 15.1663 15.1666 11.9577 15.1666 7.99967C15.1666 4.04163 11.958 0.833008 7.99992 0.833008ZM7.33325 5.33301C7.06359 5.33301 6.82052 5.49543 6.71732 5.74455C6.61415 5.99367 6.67119 6.28042 6.86185 6.47108L7.72379 7.33301L5.52851 9.52827C5.26817 9.78861 5.26817 10.2107 5.52851 10.4711C5.78887 10.7314 6.21097 10.7314 6.47133 10.4711L8.66659 8.27581L9.52852 9.13774C9.71919 9.32841 10.0059 9.38547 10.2551 9.28227C10.5042 9.17907 10.6666 8.93601 10.6666 8.66634V5.99967C10.6666 5.63149 10.3681 5.33301 9.99992 5.33301H7.33325Z" fill="#4416FF" />
                          </g>
                          <defs>
                            <clipPath id="clip0_5927_108054">
                              <rect width="16" height="16" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </a>
                    </div>

                    <div class="img1 image-anime">
                      <img src="assets/img/all-images/service/service-img21.png" alt="" />
                    </div>
                  </div>
                </div>

                <div class="col-lg-3 col-md-6">
                  <div class="service4-boxarea">
                    <div class="content-area">
                      <a href="#" class="title">Massage Therapy</a>
                      <div class="space16"></div>
                      <p>We provide Massage therapy limited to including Swedish (for relaxation), Deep Tissue (for chronic pain), Sports (for athletes), and Hot Stone (for tension relief) and many other offering different benefits.</p>
                      <div class="space24"></div>
                      <a href="https://wa.me/256755260852" target='_blank' class="readmore">
                        Learn More
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                          <g clip-path="url(#clip0_5927_10805)">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.99992 0.833008C4.04188 0.833008 0.833252 4.04163 0.833252 7.99967C0.833252 11.9577 4.04188 15.1663 7.99992 15.1663C11.958 15.1663 15.1666 11.9577 15.1666 7.99967C15.1666 4.04163 11.958 0.833008 7.99992 0.833008ZM7.33325 5.33301C7.06359 5.33301 6.82052 5.49543 6.71732 5.74455C6.61415 5.99367 6.67119 6.28042 6.86185 6.47108L7.72379 7.33301L5.52851 9.52827C5.26817 9.78861 5.26817 10.2107 5.52851 10.4711C5.78887 10.7314 6.21097 10.7314 6.47133 10.4711L8.66659 8.27581L9.52852 9.13774C9.71919 9.32841 10.0059 9.38547 10.2551 9.28227C10.5042 9.17907 10.6666 8.93601 10.6666 8.66634V5.99967C10.6666 5.63149 10.3681 5.33301 9.99992 5.33301H7.33325Z" fill="#4416FF" />
                          </g>
                          <defs>
                            <clipPath id="clip0_5927_108056">
                              <rect width="16" height="16" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </a>
                    </div>

                    <div class="img1 image-anime">
                      <img src="assets/img/all-images/service/service-img18.jpeg" alt="" />
                    </div>
                  </div>
                </div>

                <div class="col-lg-3 col-md-6">
                  <div class="service4-boxarea">
                    <div class="content-area">
                      <a href="#" class="title">Home Care Services</a>
                      <div class="space16"></div>
                      <p>We provide Skilled nursing care in the comfort of your home such as wound dressing, medication administration, and monitoring vital signs to ensure your health needs are met, daily activities like bathing, dressing etc. </p>
                      <div class="space24"></div>
                      <a href="https://wa.me/256755260852" target='_blank' class="readmore">
                        Learn More
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                          <g clip-path="url(#clip0_5927_10805)">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.99992 0.833008C4.04188 0.833008 0.833252 4.04163 0.833252 7.99967C0.833252 11.9577 4.04188 15.1663 7.99992 15.1663C11.958 15.1663 15.1666 11.9577 15.1666 7.99967C15.1666 4.04163 11.958 0.833008 7.99992 0.833008ZM7.33325 5.33301C7.06359 5.33301 6.82052 5.49543 6.71732 5.74455C6.61415 5.99367 6.67119 6.28042 6.86185 6.47108L7.72379 7.33301L5.52851 9.52827C5.26817 9.78861 5.26817 10.2107 5.52851 10.4711C5.78887 10.7314 6.21097 10.7314 6.47133 10.4711L8.66659 8.27581L9.52852 9.13774C9.71919 9.32841 10.0059 9.38547 10.2551 9.28227C10.5042 9.17907 10.6666 8.93601 10.6666 8.66634V5.99967C10.6666 5.63149 10.3681 5.33301 9.99992 5.33301H7.33325Z" fill="#4416FF" />
                          </g>
                          <defs>
                            <clipPath id="clip0_5927_108053">
                              <rect width="16" height="16" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </a>
                    </div>

                    <div class="img1 image-anime">
                      <img src="assets/img/all-images/service/service-img20.jpg" alt="" />
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>


          <div class="contact-heading">
            <div class="space100 d-lg-block d-none"></div>
            <div class="space50 d-lg-none d-block"></div>
            <div class="container">
              <div class="row">
                <div class="col-lg-8 m-auto">
                  <div class="heading4 text-center space-margin60">
                    <h5 class="vl-section-subtitle">NMRC<span> | </span>Ready to Take the First Step? <svg xmlns="http://www.w3.org/2000/svg" width="13" height="8" viewBox="0 0 13 8" fill="none">
                      <path d="M0.667969 4.00033H11.049M8.00137 7.33366L11.3346 4.00033L8.0013 0.666992" stroke="#02015A" stroke-width="1.5" />
                    </svg>
                    </h5>
                    <div class="space24"></div>
                    <h2 class="vl-section-title text-anime-style-3">Book Consultation With Ntinda Medical</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="contact1-section-area4" style={{ backgroundImage: `url(assets/img/all-images/contact/contact-img1.png)`, backgroundPosition: 'center top', backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }} >
            {/* style="background-image: url(assets/img/all-images/contact/contact-img1.png); background-position: center top; background-repeat: no-repeat; background-size: cover;" */}
            <img src="assets/img/all-images/bg/contact-bg.png" alt="" class="contact-bg" />
            <div class="container">
              <div class="row">
                <div id='serveme' class="col-lg-7">
                  <div class="contact-single-boxarea">
                    <div class="row">
                      <div class="col-lg-6 col-md-6" data-aos-duration="800">
                        <div class="single-box">
                          <div class="icons">
                            <svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none">
                              <path d="M16.305 29.3327C23.6688 29.3327 29.6383 23.3631 29.6383 15.9993C29.6383 8.63555 23.6688 2.66602 16.305 2.66602C8.94122 2.66602 2.97168 8.63555 2.97168 15.9993C2.97168 23.3631 8.94122 29.3327 16.305 29.3327Z" stroke="#1C293F" stroke-width="2.5" />
                              <path d="M16.9351 9.15785C16.9351 8.51839 16.4167 8 15.7772 8C15.1378 8 14.6194 8.51839 14.6194 9.15785H16.9351ZM18.9116 18.3738C18.4594 17.9217 17.7264 17.9217 17.2743 18.3738C16.8221 18.826 16.8221 19.559 17.2743 20.0112L18.9116 18.3738ZM19.59 22.3269C20.0421 22.7791 20.7751 22.7791 21.2273 22.3269C21.6795 21.8747 21.6795 21.1417 21.2273 20.6895L19.59 22.3269ZM14.6194 9.15785V14.5611H16.9351V9.15785H14.6194ZM17.2743 20.0112L19.59 22.3269L21.2273 20.6895L18.9116 18.3738L17.2743 20.0112ZM16.9351 16.8768C16.9351 17.5163 16.4167 18.0347 15.7772 18.0347V20.3504C17.6956 20.3504 19.2508 18.7951 19.2508 16.8768H16.9351ZM15.7772 18.0347C15.1378 18.0347 14.6194 17.5163 14.6194 16.8768H12.3037C12.3037 18.7951 13.8589 20.3504 15.7772 20.3504V18.0347ZM14.6194 16.8768C14.6194 16.2374 15.1378 15.719 15.7772 15.719V13.4033C13.8589 13.4033 12.3037 14.9585 12.3037 16.8768H14.6194ZM15.7772 15.719C16.4167 15.719 16.9351 16.2374 16.9351 16.8768H19.2508C19.2508 14.9585 17.6956 13.4033 15.7772 13.4033V15.719Z" fill="#1C293F" />
                            </svg>
                          </div>
                          <div class="text">
                            <h4>Schedule</h4>
                            <div class="space14"></div>
                            <a href="#">Mon-Sun: 7 AM – 9 PM</a>
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-6 col-md-6" data-aos-duration="900">
                        <div class="single-box">
                          <div class="icons">
                            <svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none">
                              <path d="M16.3031 28C20.9697 23.2 25.6364 18.9019 25.6364 13.6C25.6364 8.29807 21.4577 4 16.3031 4C11.1484 4 6.96973 8.29807 6.96973 13.6C6.96973 18.9019 11.6364 23.2 16.3031 28Z" stroke="#1C293F" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M16.3037 17.332C18.5129 17.332 20.3037 15.5412 20.3037 13.332C20.3037 11.1229 18.5129 9.33203 16.3037 9.33203C14.0945 9.33203 12.3037 11.1229 12.3037 13.332C12.3037 15.5412 14.0945 17.332 16.3037 17.332Z" stroke="#1C293F" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                          </div>
                          <div class="text">
                            <h4>locations</h4>
                            <div class="space14"></div>

                            <Link>Ntinda Stretcher Road</Link>
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-6 col-md-6" data-aos-duration="1000">
                        <div class="single-box">
                          <div class="icons">
                            <svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none">
                              <path d="M6.13704 24.0013L12.8037 16.0013M27.4704 24.0013L20.8037 16.0013M4.80371 10.668L14.437 17.0901C15.2924 17.6604 15.72 17.9456 16.1822 18.0562C16.5908 18.1542 17.0166 18.1542 17.4252 18.0562C17.8874 17.9456 18.315 17.6604 19.1704 17.0901L28.8037 10.668M9.07038 25.3346H24.537C26.0305 25.3346 26.7773 25.3346 27.3477 25.044C27.8494 24.7884 28.2574 24.3804 28.513 23.8786C28.8037 23.3082 28.8037 22.5614 28.8037 21.068V10.9346C28.8037 9.44117 28.8037 8.69442 28.513 8.124C28.2574 7.62222 27.8494 7.21428 27.3477 6.95862C26.7773 6.66797 26.0305 6.66797 24.537 6.66797H9.07038C7.57691 6.66797 6.83016 6.66797 6.25974 6.95862C5.75796 7.21428 5.35002 7.62222 5.09436 8.124C4.80371 8.69442 4.80371 9.44116 4.80371 10.9346V21.068C4.80371 22.5614 4.80371 23.3082 5.09436 23.8786C5.35002 24.3804 5.75796 24.7884 6.25974 25.044C6.83016 25.3346 7.5769 25.3346 9.07038 25.3346Z" stroke="#1C293F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                          </div>
                          <div class="text">
                            <h4>Our Email</h4>
                            <div class="space14"></div>
                            <a href="mailto:info@ntindamedic.com">info@ntindamedic.com</a>
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-6 col-md-6" data-aos-duration="1100">
                        <div class="single-box">
                          <div class="icons">
                            <svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none">
                              <path d="M19.037 7.99935C20.3394 8.25344 21.5362 8.89036 22.4745 9.8286C23.4128 10.7668 24.0497 11.9637 24.3037 13.266M19.037 2.66602C21.7428 2.9666 24.2658 4.17824 26.1921 6.10203C28.1182 8.0258 29.3332 10.5474 29.637 13.2527M24.9704 27.9993C13.5565 27.9993 4.30371 18.7465 4.30371 7.33268C4.30371 6.81772 4.32255 6.30716 4.35956 5.80166C4.40204 5.22151 4.42328 4.93144 4.57531 4.66739C4.70123 4.4487 4.92438 4.2413 5.15168 4.13168C5.42612 3.99935 5.74622 3.99935 6.38639 3.99935H10.1428C10.6812 3.99935 10.9503 3.99935 11.1811 4.08795C11.3849 4.16622 11.5664 4.29334 11.7096 4.45815C11.8717 4.64472 11.9637 4.8977 12.1477 5.40363L13.7025 9.67942C13.9165 10.2681 14.0236 10.5624 14.0054 10.8416C13.9894 11.0878 13.9053 11.3248 13.7626 11.5261C13.6009 11.7544 13.3323 11.9155 12.7952 12.2378L10.9704 13.3327C12.5729 16.8645 15.4372 19.7325 18.9704 21.3327L20.0653 19.5079C20.3876 18.9707 20.5486 18.7021 20.7769 18.5404C20.9782 18.3977 21.2152 18.3136 21.4614 18.2976C21.7406 18.2795 22.035 18.3865 22.6237 18.6005L26.8994 20.1553C27.4053 20.3393 27.6584 20.4313 27.8449 20.5935C28.0097 20.7367 28.1369 20.9181 28.215 21.122C28.3037 21.3527 28.3037 21.6219 28.3037 22.1603V25.9167C28.3037 26.5568 28.3037 26.877 28.1713 27.1514C28.0617 27.3787 27.8544 27.6019 27.6357 27.7278C27.3716 27.8798 27.0816 27.9009 26.5014 27.9435C25.9958 27.9805 25.4853 27.9993 24.9704 27.9993Z" stroke="#1C293F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                          </div>
                          <div class="text">
                            <h4>Phone</h4>
                            <div class="space14"></div>
                            <a href="tel:+256755260852">0755260852</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-5 servenever" data-aos-duration="1000">
                  <div class="contact-boxarea">
                    <h4>book An Appointment</h4>
                    <div class="space20"></div>
                    <p>Scheduling consultation is first step toward achieving <br class="d-lg-block d-none" /> your health and wellness goals. </p>
                    <div class="space6"></div>

                    <form method="post" onSubmit={this.onPressSchedule} >

                      <div class="row">
                        <div class="col-lg-6">
                          <div class="input-area">
                            {/* <input type="text" placeholder="Full Name*" onChange={this.onChangeFullname} /> */}
                            <Input size="large" type='text' placeholder="Full Name*" onChange={this.onChangeFullname} />
                          </div>
                        </div>

                        <div class="col-lg-6">
                          <div class="input-area">
                            {/* <input type="text" placeholder="Phone Number*" onChange={this.onChangePhone} /> */}
                            <Input size="large" type='text' placeholder="Phone Number*" onChange={this.onChangePhone} />
                          </div>
                        </div>

                        <div class="col-lg-6">
                          <div class="input-area">
                            {/* <input type="email" placeholder="Email Address*" onChange={this.onChangeEmail} /> */}
                            <Input size="large" type='text' placeholder="Email Address*" onChange={this.onChangeEmail} />
                          </div>
                        </div>

                        <div class="col-lg-6">
                          <div class="input-area">
                            <select class="nice-select" onChange={this.onChangeType}>
                              <option value="" data-display="Service Type">Service Type</option>
                              <option value="Consultation"> Consultation</option>
                              <option value="General Orthopedic Services"> General Orthopedic Services</option>
                              <option value="Specialist Services"> Specialist Services</option>
                            </select>
                          </div>
                        </div>

                        <div class="col-lg-6">
                          <div class="input-area">
                            <select class=" nice-select" onChange={this.onChangeDoctor}>
                              <option value="" data-display="Select Doctor*">Select Doctor*</option>
                              <option value="Dr. Julius Okello"> Dr. Julius Okello - Team Lead</option>
                              <option value="Dr. Nicholas Byaruhanga"> Dr. Nicholas Byaruhanga - Nutritionist</option>
                              <option value="Dr. Ochan Innocent"> Dr. Ochan Innocent - Physiotherapist</option>
                              <option value="Dr. Natukunda Patience"> Dr. Natukunda Patience - Nursing</option>
                              <option value="Dr. Ebyarimpa Medard"> Dr. Ebyarimpa Medard - surgeon</option>
                            </select>
                          </div>
                        </div>

                        <div class="col-lg-6">
                          <div class="input-area">
                            <input type="date" onChange={this.onChangeDate} />
                          </div>
                        </div>

                        <div class="col-lg-12">
                          <div class="input-area">

                            <textarea placeholder="Your Message" onChange={this.onChangeDesc}></textarea>

                            {/* <TextArea
                              showCount
                              maxLength={100}
                              style={{ height: 120, resize: 'none' }}
                              onChange={this.handleDescription}
                              placeholder="About the adventure"
                            /> */}
                          </div>


                          <Notification
                            message={{
                              type: this.state.type,
                              info: this.state.info,
                            }}
                          />

                        </div>


                        <div class="col-lg-12">
                          <div class="space10"></div>
                          <div class="input-area">

                            <button type="submit" class="vl-btn7" disabled={this.state.load}>

                              {this.state.load ? (<>
                                <span style={{ margin: '0 20px' }} class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                Scheduling your  ...
                              </>
                              ) : (<>Schedule Your Visit Now</>)}
                            </button>

                          </div>
                        </div>
                      </div>

                    </form>

                    {/* <div class="row">
                      <div class="col-lg-6">
                        <div class="input-area">
                          <input type="text" placeholder="Full Name*" />
                        </div>
                      </div>

                      <div class="col-lg-6">
                        <div class="input-area">
                          <input type="number" placeholder="Phone Number*" />
                        </div>
                      </div>

                      <div class="col-lg-6">
                        <div class="input-area">
                          <input type="email" placeholder="Email Address*" />
                        </div>
                      </div>

                      <div class="col-lg-6">
                        <div class="input-area">
                          <select name="country" id="country" class="country-area nice-select">
                            <option value="1" data-display="Service Type">Service Type</option>
                            <option value=""> General Medical Services</option>
                            <option value=""> Specialist Services</option>
                            <option value=""> Women’s Health Services</option>
                            <option value=""> Mental Health and Wellness</option>
                            <option value=""> Diagnostic and Laboratory Services</option>
                          </select>
                        </div>
                      </div>

                      <div class="col-lg-6">
                        <div class="input-area">
                          <select name="country" id="country1" class="country-area nice-select">
                            <option value="1" data-display="Select Doctor*">Select Doctor*</option>
                            <option value=""> Dr. Emily Carter - Cardiologist</option>
                            <option value=""> Dr. Michael - Orthopedic Surgeon</option>
                            <option value=""> Dr. Olivia - Dermatologist</option>
                            <option value=""> Dr. Ethan Brown - Pediatrician</option>
                            <option value=""> Dr. Ava Davis - Neurologist</option>
                          </select>
                        </div>
                      </div>

                      <div class="col-lg-6">
                        <div class="input-area">
                          <input type="date" />
                        </div>
                      </div>

                      <div class="col-lg-12">
                        <div class="input-area">
                          <textarea placeholder="Your Message"></textarea>
                        </div>
                      </div>

                      <div class="col-lg-12">
                        <div class="space10"></div>
                        <div class="input-area">
                          <button type="submit" class="vl-btn4">Complete Your Appointment Now <span><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M11 0.25C5.06294 0.25 0.25 5.06294 0.25 11C0.25 16.9371 5.06294 21.75 11 21.75C16.9371 21.75 21.75 16.9371 21.75 11C21.75 5.06294 16.9371 0.25 11 0.25ZM10 7C9.5955 7 9.2309 7.24364 9.0761 7.61732C8.92134 7.99099 9.0069 8.42111 9.2929 8.70711L10.5858 10L7.29289 13.2929C6.90237 13.6834 6.90237 14.3166 7.29289 14.7071C7.68342 15.0976 8.31658 15.0976 8.70711 14.7071L12 11.4142L13.2929 12.7071C13.5789 12.9931 14.009 13.0787 14.3827 12.9239C14.7564 12.7691 15 12.4045 15 12V8C15 7.44772 14.5523 7 14 7H10Z" fill="white" />
                          </svg></span></button>
                        </div>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="space100 d-lg-block d-none"></div>
          <div class="space50 d-lg-none d-block"></div>


          {<Footer />}
        </body>
      </>
    )
  }
}
export default Services